import React from "react";
import {
  Accordion,
  DoubleContent,
  Headline,
  LinkPrimary,
  SectionContent,
  TextBodyAccordion,
} from "../../../../components";
import { envs } from "../../../../config";

const prestamistaAccordion = [
  {
    title: "Sobre o seguro prestamista",
    body: (
      <TextBodyAccordion>
        Pensando no cuidado com a sua família, nós oferecemos o Seguro
        Prestamista, que é opcional e cobrado a partir da 2ª parcela. Ao
        adquiri-lo, você garante o pagamento das parcelas do seu consórcio, em
        caso de morte ou invalidez total e permanente e ainda concorre a
        sorteios mensais no valor de R$ 50 mil.
      </TextBodyAccordion>
    ),
  },
  {
    title: "Condições gerais",
    body: (
      <>
        <TextBodyAccordion>
          <strong>Consórcio Imobiliário</strong>
        </TextBodyAccordion>
        <TextBodyAccordion>
          <LinkPrimary
            target="_blank"
            href={`${envs.hostStaticCdn}/AreaAberta/Consorcio/CondicoesGerais/Condicoes-Gerais-do-Seguro-Prestamista-Consorcio-Imobiliario.pdf`}
          >
            Consulte as condições gerais
          </LinkPrimary>{" "}
          do Seguro Prestamista vigente desde 01/09/2016 para todos os contratos
          ativos.
        </TextBodyAccordion>
        <TextBodyAccordion>
          <strong>Consórcio de Veículos</strong>
        </TextBodyAccordion>
        <TextBodyAccordion>
          <LinkPrimary
            target="_blank"
            href={`${envs.hostStaticCdn}/AreaAberta/Consorcio/CondicoesGerais/Condicoes-Gerais-do-Seguro-Prestamista-Consorcio-Veiculos.pdf`}
          >
            Consulte as condições gerais
          </LinkPrimary>{" "}
          do Seguro Prestamista vigente desde 01/09/2016 para todos os contratos
          ativos.
        </TextBodyAccordion>
      </>
    ),
  },
  {
    title: "Regulamento dos sorteios",
    body: (
      <TextBodyAccordion>
        Se você tem um seguro prestamista para o seu consórcio, você concorre a
        sorteios mensais no valor de R$ 50 mil.{" "}
        <LinkPrimary
          target="_blank"
          href={`${envs.hostStaticCdn}/AreaAberta/Consorcio/Regulamentos/Regulamento_da_Premiacao_por_Sorteios_Consorcios.pdf`}
        >
          Consulte aqui o regulamento dos sorteios.
        </LinkPrimary>
      </TextBodyAccordion>
    ),
  },
  {
    title: "Riscos excluídos",
    body: (
      <>
        <TextBodyAccordion>
          <strong>Consórcio Imobiliário</strong>
        </TextBodyAccordion>
        <TextBodyAccordion>
          <LinkPrimary
            target="_blank"
            href={`${envs.hostStaticCdn}/AreaAberta/Consorcio/RiscosExcluidos/Apolice_Prestamista_Vida.pdf`}
          >
            Consulte os riscos excluídos
          </LinkPrimary>{" "}
          do Seguro Prestamista para consórcios adquiridos entre 18/10/2010 e
          31/08/2016.
        </TextBodyAccordion>
        <TextBodyAccordion>
          <strong>Consórcio de Veículos</strong>
        </TextBodyAccordion>
        <TextBodyAccordion>
          <LinkPrimary
            target="_blank"
            href={`${envs.hostStaticCdn}/AreaAberta/Consorcio/RiscosExcluidos/Apolice_Prestamista_Auto.pdf`}
          >
            Consulte os riscos excluídos
          </LinkPrimary>{" "}
          do Seguro Prestamista para consórcios adquiridos entre 20/10/2005 e
          31/08/2016.
        </TextBodyAccordion>
      </>
    ),
  },
];

const SeguroPrestamista = () => {
  return (
    <>
      <SectionContent>
        <DoubleContent
          leftContent={
            <Headline nivel="2" styleAs="5" leadMobile>
              Seguro Prestamista
            </Headline>
          }
          rightContent={<Accordion listItems={prestamistaAccordion} />}
        />
      </SectionContent>
    </>
  );
};

export default SeguroPrestamista;
